var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FoundationCode } from '@debbie/common/dist/customers';
import helpers from '@debbie/common/dist/economy/helpers';
import { c } from '@debbie/cortex/dist';
import * as debtRegisterAPI from '@debbie/cortex/dist/api/debt-register';
import { Button, Modal, Input, Select, DateInput } from '..';
const MoveToOpenModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [amount, setAmount] = useState(null);
    const [foundationCode, setFoundationCode] = useState(null);
    const [foundationDate, setFoundationDate] = useState(moment().subtract(15, 'days'));
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!Number.isNaN(amount))
            return;
        if (!props.caseVouchers) {
            setAmount(0);
            return;
        }
        const balance = -helpers.overview.balance(props.caseVouchers);
        setAmount(balance / 100);
    }, [props.caseVouchers]);
    return (React.createElement(Modal, { header: "Tilf\u00F8j fundament til RKI-registrering", onToggle: props.toggleMoveToOpenModal, maxWidth: "350px" },
        React.createElement(Input, { placeholder: "Bel\u00F8b", type: "number", value: amount || '', onChange: (e) => setAmount(e.target.value) }),
        React.createElement(Select, { value: foundationCode, onChange: (e) => setFoundationCode(e.target.value) },
            React.createElement("option", { value: "" },
                "- ",
                lang.RKI.chooseFoundationType,
                " -"),
            Object.values(FoundationCode).map((e) => (React.createElement("option", { key: e, value: e }, lang.RKI.foundationCode[e])))),
        React.createElement(DateInput, { allowNull: true, placeholder: lang.RKI.dateFoundation, onChange: (d) => setFoundationDate(d), value: foundationDate || undefined, maxDate: moment().toDate() }),
        React.createElement(Button, { disabled: !(foundationCode &&
                foundationDate &&
                parseInt(`${(amount || 0) * 100}`)), loading: loading, block: true, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    if (!foundationCode || !foundationDate)
                        return alert('Mangler oplysninger om fundamentet');
                    setLoading(true);
                    if (!props.userId)
                        throw new Error('Ingen debitor valgt.');
                    if (!props.rkiReferenceId)
                        throw new Error('Intet rkiReferenceId valgt.');
                    yield debtRegisterAPI.rkiMoveToOpen(props.userId, props.case.caseId, props.rkiReferenceId, {
                        amount: parseInt(`${(amount || 0) * 100}`),
                        foundationCode: foundationCode,
                        foundationDate: foundationDate.format(),
                    });
                    yield c.cases.getById(props.case.id);
                    yield c.customers.getById(props.customer.customerId);
                    props.toggleMoveToOpenModal();
                }
                catch (error) {
                    console.error(error);
                    const err = (error === null || error === void 0 ? void 0 : error.message) ? JSON.parse(error.message) : error;
                    alert(err.description || err);
                }
                setLoading(true);
            }) }, "Tilf\u00F8j fundament til RKI-registrering")));
};
export default MoveToOpenModal;
//# sourceMappingURL=MoveToOpenModal.js.map